import React from "react";
import { Col, Row, Divider } from "antd";

import { PlusCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import IntlMessages from "../../../util/IntlMessages";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { APP_ROUTES } from "../../../constants/Routes";
import { access } from "../../../util/utilz";

const HolidaysHeader = () => {
  return (
    <div>
      <Row className="p-10 Add-button">
        <Col>
          <p className="header-tag">
            {<IntlMessages id={"Addnew.holidays"} />}
          </p>
        </Col>
        {access("holidays", "add") && (
          <Col>
            <Link to={APP_ROUTES.ADDNEWHOLIDAYS}>
              <ButtonComponent
                className="buttons"
                icon={<PlusCircleOutlined />}
                type="primary"
                label="Add New"
              />
            </Link>
          </Col>
        )}
      </Row>

      <Divider />
    </div>
  );
};

export default HolidaysHeader;
